<template>
  <div class="dapp-card">
    <div class="dapp-simple-content">
      <h2>{{ $t('menu.about') }}</h2>
      <div v-html="$t('content.about')"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'about'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/about.vue